import React, { useState } from "react";
import { reactNativeDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const ReactNativeDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire skilled React Native developers in India to build high-performance mobile apps. Get reliable, scalable & cost-effective solutions. Contact us today!"/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Skilled React Native Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-reactnative-developers"/>
<meta property="og:description" content="Hire skilled React Native developers in India to build high-performance mobile apps. Get reliable, scalable & cost-effective solutions. Contact us today!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Skilled React Native Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire skilled React Native developers in India to build high-performance mobile apps. Get reliable, scalable & cost-effective solutions. Contact us today!"/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-reactnative-developers"/>
<title>Hire Skilled React Native Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16  mt-4">
          <div className="lg:w-3/4  lg:text-left mt-10">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Skilled React Native Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              Searching for expert React Native developers for your next mobile
              app project? Look no further—partner with Ayanshtech’s talented
              team to transform your ideas into impactful apps while enjoying
              cost-effective solutions and unmatched benefits.
              <br />
              <br />
              Leverage the expertise of Ayanshtech’s top-notch React Native
              professionals to design and build modern cross-platform mobile
              applications tailored for startups, SMEs, and enterprises. Choose
              flexible engagement models to hire developers on an hourly,
              monthly, or full-time basis.
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a React Native Developer
            </button>
          </div>

          <div className="flex justify-center  mb-5 mt-5">
            <img
              src="\assets\images\headerSection\hireReactNative\img1.webp"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Proficiency of Our React Native Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Our talented React Native developers craft innovative and efficient
          mobile solutions tailored to meet your specific requirements. Hire our
          experienced developers to overcome your app development hurdles and
          achieve your project goals seamlessly.
        </p>
      </div>

      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">React Native Consultation</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon9.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Comprehensive API Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon10.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Custom React Native App Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Hybrid and Cross-Platform Solutions</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Expertise in HTML, CSS, and JavaScript</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon13.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Quality Assurance and Testing Services</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Hire Expert React Native Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Leverage React Native's powerful cross-platform capabilities to create
          mobile apps that offer exceptional user experiences.
        </p>
      </div>

      <div className=" ">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireReactNative\img2.png"
              alt="Laptop showcasing data"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  React Native developers enable faster app development by
                  reusing code across iOS and Android platforms.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our team builds frameworks that deliver flawless user
                  experiences for diverse mobile applications.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Modifications made to the codebase are seamlessly reflected
                  across both Android and iOS versions of your app.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  React Native apps are designed to scale effortlessly and adapt
                  to evolving business requirements.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Achieve cost-efficient development with a unified codebase for
                  creating apps for multiple platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div className="max-w-3xl mx-auto p-4 mt-10 w-full ">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {reactNativeDevFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default ReactNativeDevelopers;
